import { useAuthStore } from "~/store/auth/auth.store";

// Non-admins have no Sessions list: they only reach /sessions through a session-detail link (?id=).
export default defineNuxtRouteMiddleware((to) => {
  const authStore = useAuthStore();

  if (authStore.isCompanyAdmin || authStore.isGroupAdmin || to.query.id) return;

  return navigateTo("/registrations", { replace: true });
});
